import React from 'react'

function ModeSelector() {
    const modes = [{
        name: "Party Mode",
        className: "partyMode"
    },{
        name: "Hard Mode",
        className: "hardMode"
    },{
        name: "Safe Mode",
        className: "safeMode"
    },{
        name: "Snooze",
        className: "snoozeMode"
    }];
    const modesAsElements = [];
    for (let i = 0; i < modes.length; i++) {
        modesAsElements.push(<option value={i} key={i}>{modes[i].name}</option>);
    }
    function deactivateAllModes(){
        for (let i = 0; i < modes.length; i++) {
            document.body.classList.remove(modes[i].className);
        }
    }
    function handleModeChange(event){
        deactivateAllModes();
        const optionValue = event.target.value;
        if(optionValue==="default"){return}
        document.body.classList.add(modes[parseInt(optionValue)].className);
        if(optionValue==="3"){ //(Snooze mode)
            window.scrollTo(0,document.body.scrollHeight);
        }
    }
    return (
        <select onChange={handleModeChange}>
            <option value="default">Default</option>
            {modesAsElements}
        </select>
    )
}

export default ModeSelector